<label class="cg-admin-field leads-filters__field crm-list-filters">
  <span class="cg-admin-field__label">Filters</span>
  <div class="crm-list-filters__wrap">
    <button
      type="button"
      class="cg-select crm-list-filters__trigger"
      [attr.aria-expanded]="open()"
      aria-haspopup="menu"
      (click)="toggleOpen()"
    >
      <span class="crm-list-filters__trigger-label">{{ triggerLabel() }}</span>
      <span class="crm-list-filters__chevron" aria-hidden="true"></span>
    </button>

    @if (open()) {
      <div class="crm-list-filters__panel" role="menu">
        @if (!activeCategory()) {
          <button
            type="button"
            class="crm-list-filters__item"
            role="menuitem"
            (click)="openCategory('assignedTo')"
          >
            <span class="crm-list-filters__item-label">Assigned to</span>
            <span class="crm-list-filters__item-value">{{ assignedToLabel() }}</span>
            <span class="crm-list-filters__item-arrow" aria-hidden="true"></span>
          </button>
          <button
            type="button"
            class="crm-list-filters__item"
            role="menuitem"
            (click)="openCategory('status')"
          >
            <span class="crm-list-filters__item-label">Status</span>
            <span class="crm-list-filters__item-value">{{ statusLabel() }}</span>
            <span class="crm-list-filters__item-arrow" aria-hidden="true"></span>
          </button>
          <button
            type="button"
            class="crm-list-filters__item"
            role="menuitem"
            (click)="openCategory('destination')"
          >
            <span class="crm-list-filters__item-label">Destination</span>
            <span class="crm-list-filters__item-value">{{ destinationLabel() }}</span>
            <span class="crm-list-filters__item-arrow" aria-hidden="true"></span>
          </button>
          <button
            type="button"
            class="crm-list-filters__clear"
            role="menuitem"
            [disabled]="activeCount() === 0"
            (click)="clearFilters()"
          >
            Clear
          </button>
        } @else {
          <button type="button" class="crm-list-filters__back" (click)="backToCategories()">
            <span class="crm-list-filters__back-arrow" aria-hidden="true"></span>
            <span>{{ nestedTitle() }}</span>
          </button>
          <div class="crm-list-filters__options" role="group" [attr.aria-label]="nestedTitle()">
            @for (option of nestedOptions(); track option.value + ':' + option.label) {
              <button
                type="button"
                class="crm-list-filters__option"
                [class.crm-list-filters__option--selected]="option.value === nestedSelectedValue()"
                role="menuitemradio"
                [attr.aria-checked]="option.value === nestedSelectedValue()"
                (click)="selectOption(option.value)"
              >
                <span>{{ option.label }}</span>
                @if (option.value === nestedSelectedValue()) {
                  <span class="crm-list-filters__check" aria-hidden="true"></span>
                }
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
</label>
